import Spacing from 'ui/types/spacing';
import styled, { css, ExecutionContext } from 'styled-components';

const documentViewDefaults = {
  embedHeight: '19rem',
};

interface DocumentViewProps {
  $borderd?: boolean;
  $height?: 'medium';
  $spacing?: Spacing;
}

function getHeight({ $height }: ExecutionContext & DocumentViewProps) {
  return css`
    embed {
      height: ${$height ? documentViewDefaults.embedHeight : '100%'};
    }
  `;
}

function getResizeContent() {
  return css`
    embed {
      object-fit: contain;
    }
  `;
}

function getBorder({ $borderd }: ExecutionContext & DocumentViewProps) {
  if (!$borderd) return null;

  return css`
    embed {
      border: 2px solid black;
    }
  `;
}

function getSpacing({ theme, $spacing }: ExecutionContext & DocumentViewProps) {
  if (!$spacing) return null;

  const spacing = theme.spacing[$spacing];

  return css<DocumentViewProps>`
    &:not(:last-child) {
      margin-bottom: ${spacing}rem;
    }
  `;
}

export const DocumentView = styled.div<DocumentViewProps>`
  ${getBorder};
  ${getHeight};
  ${getSpacing};
  ${getResizeContent};
`;
